import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=a45a54b8&scoped=true"
import script from "./AppLogin.vue?vue&type=script&lang=js"
export * from "./AppLogin.vue?vue&type=script&lang=js"
import style0 from "./AppLogin.vue?vue&type=style&index=0&id=a45a54b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45a54b8",
  null
  
)

export default component.exports